import Component from './Component'

export default class CheckBox extends Component {

	static _type = 'CheckBox'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el
	_indeterminate

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('input')
		this.custom_el = this.base.querySelector('.custom-control')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Create bound event handlers and register them
		this.inputListener = CheckBox._inputListener.bind(this)
		this.updateListener = CheckBox._updateListener.bind(this)
		$(this.input_el).on('input', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event

		// Three state checkboxes need an initial check, the third state cannot be rendered into DOM directly
		if ('mode' in this.params && this.params.mode == 'three-state') {
			if (this.form.data[this.params.name] === 2) {
				$(this.input_el).get(0).checked = false
				$(this.input_el).get(0).indeterminate = true
				this._indeterminate = true
			}
		}
	}

	static _inputListener (event) {

		if ('mode' in this.params && this.params.mode == 'three-state') {
			if (this._indeterminate) {
				this._indeterminate = false
				$(this.input_el).get(0).checked = false
			} else {
				if (!$(this.input_el).get(0).checked) {

					// We're setting the value to 2
					$(this.input_el).get(0).indeterminate = true
					this._indeterminate = true

					this.form.data[this.params.name] = 2
					return
				}
			}
		}

		// Send data to the record
		this.form.data[this.params.name] = $(this.input_el).get(0).checked ? 1 : 0
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if ('mode' in this.params && this.params.mode == 'three-state') {
			if (value !== 2) {
				this._indeterminate = false
				$(this.input_el).get(0).indeterminate = false
			} else {
				$(this.input_el).get(0).checked = false
				$(this.input_el).get(0).indeterminate = true
				this._indeterminate = true

				// Render validation
				this.renderValidation(errors)
				return
			}
		}

		if ($(this.input_el).get(0).checked != (value == 1)) {
			$(this.input_el).get(0).checked = (value == 1)
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.custom_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.custom_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.input_el).off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.input_el
		delete this.custom_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
